import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { User, UiState, Activity } from '../models';
import _ from 'lodash';
import { uiState } from '../models/ui-state';
import { Invite } from '../models/invite';
import { Like } from '../models/like';
import { Post } from '../models/post';


@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  // Current User
  // private _uiState: UiState;
  user: ReplaySubject<User>;
  conversation: ReplaySubject<User>;
  likes: ReplaySubject<Like[]>;
  matches: ReplaySubject<User[]>;
  invitesFromMe: ReplaySubject<Invite[]>;
  invitesToMe: ReplaySubject<Invite[]>;
  invites: ReplaySubject<Invite[]>;
  myUpcomingPosts: ReplaySubject<Post[]>;
  postCount: ReplaySubject<number>;
  sidenav: ReplaySubject<boolean>; // holds value of sidenav opened or closed
  uiState: ReplaySubject<UiState>;
  bannedActivities: ReplaySubject<Activity[]>;
  navComm: ReplaySubject<any>;
  hasAutoLocatedOnStart: boolean = false;

  constructor() {
    // this._uiState = new UiState(); // Todo: this can be fetched from api
    this.user = new ReplaySubject(1);
    this.conversation = new ReplaySubject(1);
    this.likes = new ReplaySubject(1);
    this.matches = new ReplaySubject(1);
    this.invitesFromMe = new ReplaySubject(1);
    this.invitesToMe = new ReplaySubject(1);
    this.invites = new ReplaySubject(1);
    this.myUpcomingPosts = new ReplaySubject(1);
    this.postCount = new ReplaySubject(1);
    this.sidenav = new ReplaySubject(1);
    this.uiState = new ReplaySubject(1);
    this.bannedActivities = new ReplaySubject(1);
    this.navComm = new ReplaySubject(1);
  }

  createUiState(data:object){
    this.uiState.next(new UiState(data));
  }
}
